<a class="sr-row-action-trigger" *ngIf="targets?.length"
   [ngClass]="{'active': isOpen}"
   [tooltip]="dic.CONSTANTS.srRowAction.triggerTooltip"
   (click)="toggle($event)">
    <i class="far fa-shield-alt"></i>
</a>

<div class="sr-row-action-menu animated fadeIn" *ngIf="isOpen"
     [ngStyle]="{'top.px': menuPos.top, 'left.px': menuPos.left}"
     (click)="$event.stopPropagation()">
    <!--target picker: only when the row has more than one value (e.g. email + domain, several IPs)-->
    <div class="sr-row-action-targets" *ngIf="targets.length > 1">
        <a *ngFor="let target of targets"
           [ngClass]="{'selected': selectedTarget?.label === target.label}"
           (click)="selectedTarget = inProcess ? selectedTarget : target; pending = null;">
            {{target.label}}
        </a>
    </div>
    <span class="sr-row-action-value">{{selectedTarget?.value}}</span>

    <ng-container *ngIf="!pending">
        <div class="sr-row-action-scope">
            <span class="sr-row-action-scope-title"><i class="far fa-globe"></i>{{dic.CONSTANTS.srRowAction.allPlans}}</span>
            <div class="sr-row-action-options">
                <a class="block" (click)="pending = {scope: 'global', block: true}"><i class="far fa-ban"></i><span>{{dic.CONSTANTS.srRowAction.block}}</span></a>
                <a class="allow" *ngIf="!selectedTarget?.noGlobalAllow" (click)="pending = {scope: 'global', block: false}"><i class="far fa-check-circle"></i><span>{{dic.CONSTANTS.srRowAction.allow}}</span></a>
            </div>
        </div>
        <div class="sr-row-action-scope" *ngIf="allowPlan">
            <span class="sr-row-action-scope-title"><i class="far fa-building"></i>{{dic.CONSTANTS.srRowAction.thisPlan}}</span>
            <div class="sr-row-action-options">
                <a class="block" (click)="pending = {scope: 'plan', block: true}"><i class="far fa-ban"></i><span>{{dic.CONSTANTS.srRowAction.block}}</span></a>
                <a class="allow" (click)="pending = {scope: 'plan', block: false}"><i class="far fa-check-circle"></i><span>{{dic.CONSTANTS.srRowAction.allow}}</span></a>
            </div>
        </div>
    </ng-container>

    <div class="sr-row-action-confirm" *ngIf="pending">
        <span>
            {{pending.block ? dic.CONSTANTS.srRowAction.block : dic.CONSTANTS.srRowAction.allow}} {{dic.CONSTANTS.srRowAction.confirmValue}}
            <b>{{pending.scope === 'global' ? dic.CONSTANTS.srRowAction.forAllPlans : dic.CONSTANTS.srRowAction.inThisPlan}}</b>?
        </span>
        <div class="flxRow" style="gap: 6px; justify-content: flex-end;">
            <a class="sr-row-action-cancel" *ngIf="!inProcess" (click)="pending = null">{{dic.CONSTANTS.srRowAction.back}}</a>
            <a class="sr-row-action-apply" [ngClass]="pending.block ? 'block' : 'allow'" (click)="!inProcess && confirm()">
                <i class="far fa-spinner fa-spin" *ngIf="inProcess"></i>
                <span>{{dic.CONSTANTS.srRowAction.confirm}}</span>
            </a>
        </div>
    </div>
</div>
